import React from 'react';

export const RewardDropdown: React.FC<React.PropsWithChildren<unknown>> = () => null;
